import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const DESIGN_BASE_URL = `${API_BASE_URL}/design`;

// ==========================
// GET USER DESIGN FEED
// ==========================
export const getUserDesignFeedApi = async (
  user_id: number | string,
  page: number = 1,
  limit: number = 4
) => {
  try {
    const res = await axios.get(
      `${DESIGN_BASE_URL}/user-feed/${user_id}`,
      {
        params: {
          sort_by: "uploaded_on",
          sort_order: "desc",
          page,
          limit,
        },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: [],
      message:
        error?.response?.data?.message ||
        "Failed to fetch design photos",
      error:
        error?.response?.data ||
        error?.message,
    };
  }
};